import {
    Row, Col, Card, Table, Button, Input, Tag, Tooltip,
    Modal,
    Space,
} from "antd";
import React, { useState, useContext, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import { useNavigate } from "react-router";
import apiPath from "../../constants/apiPath";
import moment from "moment";
import lang from "../../helper/langHelper";
import { AuthContext } from "../../context/AuthContext";
import { EditOutlined, ExclamationCircleOutlined, EyeOutlined } from "@ant-design/icons";
import { AppStateContext } from "../../context/AppContext";
const Search = Input.Search;

function Index() {
    const sectionName = lang("Static Content");
    const routeName = "static-content";
    const { setPageHeading } = useContext(AppStateContext);
    setPageHeading("Static Content");
    const api = {
        status: apiPath.statusContent,
        list: apiPath.listContent,
    };

    const [searchText, setSearchText] = useState("");
    const { request } = useRequest();
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const debouncedSearchText = useDebounce(searchText, 300);
    const navigate = useNavigate();

    const view = (slug) => {
        navigate(`/${routeName}/view/${slug}`);
    };

    const edit = (slug) => {
        navigate(`/${routeName}/update/${slug}`);
    };

    const { confirm } = Modal;
    const showConfirm = (record) => {
        setTimeout(() => {
            confirm({
                icon: <ExclamationCircleOutlined />,
                content: <Button >Are you sure you want change the status ? </Button>,
                onOk() {
                    statusChange(record)
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        }, 5);
    };

    const statusChange = (record) => {
        setLoading(true);
        request({
            url: `/admin/static-content/status-change/${record}`,
            method: 'PUT',
            onSuccess: (data) => {
                setLoading(false);
                ShowToast("status Changed Successfullt", Severty.SUCCESS)
                setRefresh(prev => !prev)
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    };

    const columns = [
        {
            title: "Content Title",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Content STATUS",
            filters: [
                {
                    text: 'Active',
                    value: true,
                },
                {
                    text: 'InActive',
                    value: false,
                },
            ],
            onFilter: (value, record) => record.isActive === value,
            render: (_, { isActive, _id }) => {
                let color = isActive ? 'green' : 'red';
                return (
                    <Tag
                        onClick={(e) => showConfirm(_id)}
                        color={color}
                        key={isActive}
                    >
                        {isActive ? "Active" : "Inactive"}
                    </Tag>
                );
            },
        },
        {
            title: `${lang("Created_On")}`,
            key: "createdAt",
            dataIndex: "createdAt",
            render: (_, { createdAt }) => {
                return moment(createdAt).format("DD-MMM-YYYY");
            },
        },
        {
            title: `${lang("Action")}`,
            fixed: "right",
            render: (_, record) => {
                return (

                 <Space size="middle">
                    <Button
                      type="primary"
                      onClick={(e) => view(record.slug)}
                      icon={<EyeOutlined />}
                    />

                    <Button
                      onClick={() => {
                        edit(record.slug);
                      }}
                      icon={<EditOutlined />}
                      type="primary"
                    />
           </Space>
                );
            },
        },
    ];

    useEffect(() => {
        setLoading(true);
        fetchData(pagination);
    }, [refresh, searchText]);

    const fetchData = (pagination, filters) => {
        const filterActive = filters ? filters.is_active : null;

        request({
            url: `admin/static-content/list?status=${filterActive ? filterActive.join(",") : ""}&search=${searchText}`,
            method: "GET",
            onSuccess: (data) => {
                setLoading(false);
                setList(data.data.list.docs);
                setPagination((prev) => ({
                    current: pagination.current,
                    total: data.data.list.totalDocs,
                }));
            },
            onError: (error) => {
                setLoading(false);
                ShowToast(error, Severty.ERROR);
            },
        });
    };

    const handleChange = (pagination, filters) => {
        fetchData(pagination, filters);
    };

    const onSearch = (e) => {
        setSearchText(e.target.value);
        setPagination({ current: 1 });
    };

    return (
        <>
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs={24} xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title={sectionName + ` ${lang("Manager")}`}
                            extra={
                                <>
                                 <div className="pageHeadingSearch">
                                    <Input.Search 
                                        className="searchInput"
                                        onChange={onSearch}
                                        allowClear
                                        value={searchText}
                                        onPressEnter={onSearch}
                                        placeholder={`${lang("Search")} ${lang("By")} ${lang(
                                            "Content Title"
                                        )}`}
                                    />
                                    </div>
                                </>
                            }
                        >
                            <div className="table-responsive customPagination">
                                <Table
                                    loading={loading}
                                    columns={columns}
                                    dataSource={list}
                                    pagination={{
                                        current: pagination.current,
                                        defaultPageSize: 10,
                                        responsive: true,
                                        total: pagination.total,
                                        showSizeChanger: true,
                                        pageSizeOptions: ["10", "20", "30", "50"],
                                    }}
                                    onChange={handleChange}
                                    className="ant-border-space"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default Index;
